import styled from 'styled-components'

export const EntityMenuBottomSheetContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const EntityMenuBottomSheetAllContentContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const EntityMenuBottomSheetContentContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
